import { Link } from "react-router-dom";
import { Home as HomeIcon, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";
import { GALLERY_IMAGES } from "@/data/gallery";

export default function NotFound() {
  return (
    <div data-testid="notfound-page">
      <Seo
        title="Page not found — RDA Glasgow"
        description="We couldn't find that page. Head back to the RDA Glasgow home page or get in touch with our team."
      />
      <section className="relative bg-gradient-to-br from-rda-teal/15 via-rda-offwhite to-rda-offwhite">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-20 md:py-28">
          <div className="grid items-center gap-10 md:grid-cols-2">
            <Reveal>
              <p className="font-heading font-extrabold text-6xl text-rda-teal">404</p>
              <h1 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-rda-ink leading-[1.05]">
                This page has trotted off.
              </h1>
              <p className="mt-5 text-lg text-rda-muted max-w-md">
                We couldn't find the page you were looking for — but our ponies are still
                right here. Let's get you back on track.
              </p>
              <div className="mt-8 flex flex-wrap gap-4">
                <Button
                  asChild
                  size="lg"
                  className="rounded-full bg-rda-teal text-white hover:bg-rda-tealDark font-semibold px-7 h-12"
                  data-testid="notfound-home-cta"
                >
                  <Link to="/">
                    <HomeIcon className="mr-2 h-4 w-4" /> Back to home
                  </Link>
                </Button>
                <Button
                  asChild
                  size="lg"
                  variant="outline"
                  className="rounded-full border-rda-teal text-rda-teal hover:bg-rda-teal hover:text-white font-semibold px-7 h-12"
                  data-testid="notfound-contact-cta"
                >
                  <Link to="/contact">
                    <Mail className="mr-2 h-4 w-4" /> Get in touch
                  </Link>
                </Button>
              </div>
            </Reveal>
            <Reveal delay={0.1} className="hidden md:block">
              <div className="overflow-hidden rounded-3xl shadow-lift">
                <img
                  src={GALLERY_IMAGES.poniesNuzzling}
                  alt="Two friendly ponies nuzzling each other"
                  loading="lazy"
                  className="h-80 w-full object-cover"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
